import { VisaSubmitDataInterface } from '../interfaces/visa-submit-data.interface';

export class VisaDataModel {
  /**
   * state.
   */
  public state: string;

  /**
   * comment.
   */
  public comment?: string;

  /**
   * attachment.
   */
  public attachment?: File;

  /**
   *
   * @param data Data.
   */
  constructor(data: VisaSubmitDataInterface) {
    this.state = data.state;
    this.comment = data.comment;
    this.attachment = data.attachment;
  }
}
